
import Vue from "vue"
import type { Hall, Session, Group } from "@/types/api/program"

type TimeToHeight = (time: number) => number
type GetActiveGroup = (groupAlias: Group["alias"]) => Group

export default Vue.extend({
  props: {
    halls: { type: Array as VuePropType<Hall[]>, required: true },
    displaySessions: { type: Array as VuePropType<Session[][]>, required: true },
    activeHall: { type: String, default: null },
    timeToHeight: { type: Function as VuePropType<TimeToHeight>, required: true },
    programStart: { type: Number, required: true },
    getActiveGroup: { type: Function as VuePropType<GetActiveGroup>, required: true },
  },

  computed: {
    sessions (): Session[] {
      return this.displaySessions.flat()
        .sort((a, b) => a.start - b.start)
    },

    colWidth (): string {
      return `calc(100% / ${this.halls.length})`
    },
  },

  methods: {
    getHallIdx (hallAlias: Hall["alias"]): number {
      return this.halls.findIndex(h => h.alias === hallAlias)
    },

    getSessionWidth (session: Session): string {
      return session.fullwidth ? "100%" : this.colWidth
    },

    getSessionHeight (session: Session): string {
      const finish = this.sessions
        .find(s => s.start >= session.finish)
        ?.start || session.finish

      return `${this.timeToHeight(finish - session.start)}px`
    },

    getSessionLeft (session: Session): string {
      if (session.fullwidth) return "0"
      const sessionHallIdx = this.getHallIdx(session.track.hall.alias)
      return `calc(${sessionHallIdx} * ${this.colWidth})`
    },

    getSessionTop (session: Session): string {
      return `${this.timeToHeight(session.start - this.programStart)}px`
    },

    isSessionInActiveHall (session: Session): boolean {
      return this.activeHall === session.track.hall.alias
    },
  },
})
